import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import { colors } from '@src/common/styles/valueTokens';

interface Props {
  count: number;
  danger?: boolean;
  contained?: boolean;
  light?: boolean;
}

export const CountBadge = ({
  count,
  danger = false,
  contained = false,
  light = false,
}: Props) => {
  return <span className={badge({ danger, contained, light })}>{count}</span>;
};

const badge = ({
  danger,
  contained,
  light,
}: {
  danger: boolean;
  contained: boolean;
  light: boolean;
}) =>
  css({
    padding: `0 ${light ? theme.spacing['2'] : theme.spacing['3']}`,
    minWidth: light ? 0 : '35px',
    height: '20px',
    borderRadius: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
    lineHeight: '1em',
    border: `${light ? '1px' : '1.5px'} solid ${
      danger
        ? colors.utility.orange['700']
        : light
          ? colors.primary['80']
          : colors.neutralVariant['40']
    }`,
    color: contained
      ? colors.primary['100']
      : danger
        ? colors.utility.orange['700']
        : colors.neutralVariant['40'],
    background: !contained
      ? colors.neutral['100']
      : danger
        ? colors.utility.orange['700']
        : colors.neutralVariant['40'],
  });
